module.exports = __webpack_public_path__ + "static/media/farm-map-bg.356db6cc.png";